<template>
	<el-dialog
		title="查看店铺"
		:visible="visible"
		width="60%"
		:before-close="handleClose"
	>
		<div>
				<el-form
						:model='mallShop'
						ref='mallShopForm'
						:rules='rules'
						label-width='120px'
						:inline='true'
						size='small'
				>
						<el-form-item
								label='店铺名称'
								prop='shopName'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.shopName'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='店铺分类'
								prop='typeId'
						>
								<el-select
										placeholder='请选择店铺分类'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.typeId'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in typeList'
												:key='index'
												:label='item.typeName'
												:value='item.id'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='所属行业'
								prop='typeId'
						>
								<el-select
										clearable
										style="width: 200px"
										:disabled="mallShopState == 'check'"
										v-model="mallShop.industryId"
										placeholder="请选择"
										size="small"
								>
										<el-tree
												:data="industryList"
												:props="treeProps"
												:render-after-expand="false"
										>
												<div
														class="custom-tree-node flex items-center"
														slot-scope="{ node, data }"
												>
														<el-option
																:label="node.label"
																:value="data.id"
														> </el-option>
												</div>
										</el-tree>
								</el-select>
						</el-form-item>
						<el-form-item
								label='详细地址'
								prop='shopAddress'
						>
								<location
										style='width: 200px;'
										:areaTreeDate="provinceIdList"
										:longitude="mallShop.shopPosition.split(',')[0]"
										:latitude="mallShop.shopPosition.split(',')[1]"
										:provinceId="mallShop.provinceId"
										:cityId="mallShop.cityId"
										:areaId="mallShop.areaId"
										:streetId="mallShop.streetId"
										:address="mallShop.shopAddress"
										:disabled="mallShopState == 'check'"
										@getLocation="getLocation"
								></location>
						</el-form-item>
						<el-form-item
								label='所属省份'
								prop='provinceId'
						>
								<el-select
										placeholder='请选择省'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.provinceId'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in provinceIdList'
												:key='index'
												:label='item.name'
												:value='item.id'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='所属城市'
								prop='cityId'
						>
								<el-select
										placeholder='请选择市'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.cityId'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in cityIdList'
												:key='index'
												:label='item.name'
												:value='item.id'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='所属区县'
								prop='areaId'
						>
								<el-select
										placeholder='请选择区'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.areaId'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in areaIdList'
												:key='index'
												:label='item.name'
												:value='item.id'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='所属乡镇'
								prop='streetId'
								v-if="mallShop.provinceId != 1 && mallShop.provinceId != 2 && mallShop.provinceId != 3 && mallShop.provinceId != 4"
						>
								<el-select
										placeholder='请选择乡镇'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.streetId'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in streetIdList'
												:key='index'
												:label='item.name'
												:value='item.id'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='店铺位定'
								prop='shopPosition'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.shopPosition'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='营业时间'
								prop='openHours'
						>
								<el-time-picker
										is-range
										style='width: 200px;'
										v-model='mallShop.openHours'
										:disabled="mallShopState == 'check'"
										range-separator='至'
										format='HH:mm'
										value-format='HH:mm'
										start-placeholder='开始时间'
										end-placeholder='结束时间'
										placeholder='选择时间范围'>
								</el-time-picker>
						</el-form-item>
						<el-form-item
						label="店铺标签"
						prop="shopTags"
						>
								<el-input
										size="small"
										style="width: 200px;"
										v-model="mallShop.shopTags"
										@focus="openTabs"
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='联系人姓名'
								prop='contactPerson'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.contactPerson'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='联系人电话'
								prop='contactPhone'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.contactPhone'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<!--el-form-item
								label='积分抵扣'
								prop='contactPhone'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.scoreDiscount'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item-->
						<el-form-item
								label='店铺管理'
								prop='userId'
						>
								<GridSelect
										style='width: 200px'
										title='选择用户'
										labelName='userName'
										labelValue='id'
										:value='mallShop.userId'
										:limit='1'
										size='small'
										placeholder='请选择用户'
										:disabled="mallShopState == 'check'"
										@getValue='getValueUserId'
										:columns="USER_code"
										:searchs="USER_search"
										dataListUrl='/mpp/user/findList'
										entityBeanName='mppUser'
										queryEntityUrl='/mpp/user/get'
								>
								</GridSelect>
						</el-form-item>
						<el-form-item label="服务费类型" prop="serviceType">
								<el-select
										placeholder='请选择服务费类型'
										clearable
										style='width: 200px'
										size='small'
										v-model='mallShop.serviceType'
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in serviveTypeList'
												:key='index'
												:label='item.value'
												:value='item.key'
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item label="服务费比例" prop="serviceRatio" v-if="mallShop.serviceType">
								<el-input :disabled="mallShopState == 'check'" style='width: 200px' size="small" v-model="mallShop.serviceRatio"></el-input>
						</el-form-item>
						<el-form-item
								label="销售模式"
								prop="saleMode"
						>
								<el-select
										placeholder="请选择销售模式"
										clearable
										style="width: 200px"
										size="small"
										v-model="mallShop.saleMode"
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in saleModeEnumList'
												:key='index'
												:label="item.value"
												:value="item.key"
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label="经营类型"
								prop="operationType"
						>
								<el-select
										placeholder="请选择经营类型"
										clearable
										style='width: 200px'
										size="small"
										v-model="mallShop.operationType"
										:disabled="mallShopState == 'check'"
								>
										<el-option
												v-for='(item,index) in operationTypeList'
												:key='index'
												:label="item.value"
												:value="item.key"
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label="限时活动"
								prop="limitActivity"
						>
								<el-select
										placeholder="请选择是否参与限时活动"
										clearable
										style='width: 200px'
										size="small"
										:disabled="mallShopState == 'check'"
										v-model="mallShop.limitActivity"
								>
										<el-option
												label="开启活动"
												:value="1"
										>
										</el-option>
										<el-option
												label="结束活动"
												:value="0"
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label="活动结束时间"
								prop="activityEndTime"
								v-if="mallShop.limitActivity==1"
						>
								<el-date-picker
										style='width: 200px'
										size="small"
										format
										:disabled="mallShopState == 'check'"
										value-format="yyyy-MM-dd HH:mm:ss"
										v-model="mallShop.activityEndTime"
										type="datetime"
										placeholder="选择日期时间">
								</el-date-picker>
						</el-form-item>
						<el-form-item
								label="活动类型"
								prop="activityTypes"
								v-if="mallShop.limitActivity==1"
						>
								<el-select
										placeholder="请选择活动类型"
										clearable
										style='width: 200px'
										multiple
										size="small"
										:disabled="mallShopState == 'check'"
										v-model="mallShop.activityTypes"
								>
										<el-option
												v-for='(item,index) in activityList'
												:key='index'
												:label="item.value"
												:value="item.key"
										>
										</el-option>
								</el-select>
						</el-form-item>
						<el-form-item
								label='申请人姓名'
								prop=' applyName'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.applyName'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='申请公司名称'
								prop='applyCompany'
						>
								<el-input
										size='small'
										style='width: 200px;'
										v-model='mallShop.applyCompany'
										:disabled="mallShopState == 'check'"
								></el-input>
						</el-form-item>
						<el-form-item
								label='店铺LOGO'
								prop='shopLogo'
						>
								<template v-if="mallShopState == 'check'">
										<el-image class='preview-image' :src="mallShop.shopLogo" :preview-src-list="[mallShop.shopLogo]"></el-image>
								</template>
								<template v-else>
										<el-upload
												style='width: 200px'
												class='avatar-uploader'
												action=''
												:show-file-list='false'
												:http-request='uploadShopLogo'
												:disabled="mallShopState == 'check'"
										>
												<img v-if='mallShop.shopLogo' :src='mallShop.shopLogo' class='avatar' size='small' />
												<i v-else class='el-icon-plus avatar-uploader-icon'></i>
										</el-upload>
								</template>
						</el-form-item>
						<el-form-item
								label='店铺BANNER'
								prop='shopBanner'
						>
								<template v-if="mallShopState == 'check'">
										<el-image class='preview-image' :src="mallShop.shopBanner" :preview-src-list="[mallShop.shopBanner]"></el-image>
								</template>
								<template v-else>
										<el-upload
												style='width: 200px'
												class='avatar-uploader'
												action=''
												:show-file-list='false'
												:http-request='uploadBanner'
												:disabled="mallShopState == 'check'"
										>
												<img v-if='mallShop.shopBanner' :src='mallShop.shopBanner' class='avatar' size='small' />
												<i v-else class='el-icon-plus avatar-uploader-icon'></i>
										</el-upload>
								</template>
						</el-form-item>
						<el-form-item
								label='身份证正面'
								prop='idcardFront'
						>
								<template v-if="mallShopState == 'check'">
										<el-image class='preview-image' :src="mallShop.idcardFront" :preview-src-list="[mallShop.idcardFront]"></el-image>
								</template>
								<template v-else>
										<el-upload
												style='width: 200px'
												class='avatar-uploader'
												action=''
												:show-file-list='false'
												:http-request='uploadIdcardFront'
												:disabled="mallShopState == 'check'"
										>
												<img v-if='mallShop.idcardFront' :src='mallShop.idcardFront' class='avatar' size='small' />
												<i v-else class='el-icon-plus avatar-uploader-icon'></i>
										</el-upload>
								</template>
						</el-form-item>
						<el-form-item
								label='身份证反面'
								prop='idcardBack'
						>
								<template v-if="mallShopState == 'check'">
										<el-image class='preview-image' :src="mallShop.idcardBack" :preview-src-list="[mallShop.idcardBack]"></el-image>
								</template>
								<template v-else>
										<el-upload
												style='width: 200px'
												class='avatar-uploader'
												action=''
												:show-file-list='false'
												:http-request='uploadIdcardBack'
												:disabled="mallShopState == 'check'"
										>
												<img v-if='mallShop.idcardBack' :src='mallShop.idcardBack' class='avatar' size='small' />
												<i v-else class='el-icon-plus avatar-uploader-icon'></i>
										</el-upload>
								</template>
						</el-form-item>
						<el-form-item
								label='公司营业执照'
								prop='companyLicense'
						>
								<template v-if="mallShopState == 'check'">
										<el-image class='preview-image' :src="mallShop.companyLicense" :preview-src-list="[mallShop.companyLicense]"></el-image>
								</template>
								<template v-else>
										<el-upload
												style='width: 200px'
												class='avatar-uploader'
												action=''
												:show-file-list='false'
												:http-request='uploadCompanyLicense'
												:disabled="mallShopState == 'check'"
										>
												<img v-if='mallShop.companyLicense' :src='mallShop.companyLicense' class='avatar' size='small' />
												<i v-else class='el-icon-plus avatar-uploader-icon'></i>
										</el-upload>
								</template>
						</el-form-item>
						<el-form-item
								label="店铺公告"
								prop="shopNotice"
						>
								<el-input
										size="small"
										type="textarea"
										:rows="9"
										:disabled="mallShopState == 'check'"
										style="width: 200px;"
										v-model="mallShop.shopNotice"
								></el-input>
						</el-form-item>
				</el-form>
		</div>

		<div
				slot='footer'
				class='flex justify-end'
		>
				<el-button @click='handleClose'>关闭</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { exprotExcel, importTemplate, importDate, get, post, put,upload , deleteFun } from '@/utils/request.js';
	import Location from '@/components/location/location.vue';
	import GridSelect from '@/components/gridselect/index.vue';
	import { UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
	export default {
		data() {
			return {
				tabList: [],
				showTabs: false,

				USER_code: USER,
				USER_search: USER_SEARCH,
				saleModeEnumList: [],
				mallShopState: 'check',
				mallShop: {
						shopName: '', //店铺名称
						shopLogo: '', //店铺logo
						shopBanner: '', //店铺banner
						provinceId: '', //省
						cityId: '', //市
						areaId: '', //区
						shopAddress: '', //详细地址
						shopPosition: '', //位定
						openHours: '', //营业时间
						contactPerson: '', //联系人
						contactPhone: '', //联系电话
						scoreDiscount: '', //积分抵扣
						remarks: '', //备注
						typeId: '',
						paymentCode: '', //收款码
						userId: '', //店铺管理
						saleMode: 1, //是否可以供货
						applyName: '', //申请人姓名
						idcardFront: '', //申请人身份证正面
						idcardBack: '', //申请人身份证反面
						applyCompany: '', //申请公司名称
						companyLicense: '', //公司营业执照
						status: '', //核审状态
						createTime: '', //创建时间
						wholesalePrice: '',
						buyMinLimit: '',
						industryId: '',
						shopNotice: '',
						shopTags: '',
						streetId: '',
						operationType: '',
						limitActivity: '',
						activityEndTime: '',
						activityTypes: '',
						serviceType: '',
						serviceRatio: '',
				},
				rules: {
						shopName: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
						shopLogo: [{ required: true, message: '店铺logo不能为空', trigger: 'blur' }],
						shopBanner: [{ required: true, message: '店铺banner不能为空', trigger: 'blur' }],
						provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
						cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
						areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
						streetId: [{ required: true, message: '乡镇不能为空', trigger: 'blur' }],
						shopAddress: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
						shopPosition: [{ required: true, message: '位定不能为空', trigger: 'blur' }],
						openHours: [{ required: true, message: '营业时间不能为空', trigger: 'blur' }],
						contactPerson: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
						contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
						scoreDiscount: [{ required: true, message: '积分抵扣不能为空', trigger: 'blur' }],
						remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
						paymentCode: [{ required: true, message: '收款码不能为空', trigger: 'blur' }],
						userId: [{ required: true, message: '店铺管理不能为空', trigger: 'blur' }],
						saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
						applyName: [{ required: true, message: '申请人姓名不能为空', trigger: 'blur' }],
						idcardFront: [{ required: true, message: '申请人身份证正面不能为空', trigger: 'blur' }],
						idcardBack: [{ required: true, message: '申请人身份证反面不能为空', trigger: 'blur' }],
						applyCompany: [{ required: true, message: '申请公司名称不能为空', trigger: 'blur' }],
						companyLicense: [{ required: true, message: '公司营业执照不能为空', trigger: 'blur' }],
						status: [{ required: true, message: '核审状态不能为空', trigger: 'blur' }],
						createTime: [{ required: true, message: '创建时间不能为空', trigger: 'blur' }],
						wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
						buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
						typeId: [{ required: true, message: '店铺分类不能为空', trigger: 'blur' }],
						industryId: [{ required: true, message: '所属行业不能为空', trigger: 'blur' }],
						shopNotice: [{ required: true, message: '公告不能为空', trigger: 'blur' }],
						shopTags: [{ required: true, message: '店铺标签不能为空', trigger: 'blur' }],
						operationType: [{ required: true, message: '经营类型不能为空', trigger: 'blur' }],
						limitActivity: [{ required: true, message: '限时活动不能为空', trigger: 'blur' }],
						activityEndTime: [{ required: true, message: '活动结束时间不能为空', trigger: 'blur' }],
						activityTypes: [{ required: true, message: '活动类型不能为空', trigger: 'blur' }],
						serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
						serviceRatio: [{ required: true, message: '服务费比列不能为空', trigger: 'blur' }],
				},
				typeList: [],
				industryList: [],
				treeProps: {
						children: 'children',
						label: 'industryName'
				},
				provinceIdList: [], //省信息
				cityIdList: [], //市信息
				areaIdList: [], //区信息
				streetIdList: [],

				activityList: [],
				operationTypeList: [],
				serviveTypeList: [],
			};
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			mallShopId: {
				type: String,
				default: ''
			}
		},
		watch: {
         'mallShop.provinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.mallShop.cityId = '';
                    this.mallShop.areaId = '';
                    this.mallShop.streetId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'mallShop.cityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.mallShop.areaId = '';
                    this.mallShop.streetId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'mallShop.areaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.mallShop.streetId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },
		},
		created() {
			this.getMallShopById();
			this.getTypeList();
			this.getActivityList();
			this.getIndustryList();
			this.getSaleModeEnumList()
			this.getAddress(1);
		},
		methods: {
			getMallShopById() {
					get(`/mall/shop/get`, { id: this.mallShopId }).then((res) => {
							if (res.success) {
									this.mallShop = { ...this.mallShop, ...res.mallShop };
									this.mallShop.openHours = this.mallShop.openHours.split('-');
									if(this.mallShop.activityTypes != '' && this.mallShop.limitActivity == 1){
											this.mallShop.activityTypes = this.mallShop.activityTypes.split(',')
											for (let i = 0; i < this.mallShop.activityTypes.length; i++) {
													this.mallShop.activityTypes[i] = Number(this.mallShop.activityTypes[i]);
											}
									}
									this.getCity = true;
									this.getArea = true;
									this.street = true;
							}
					});
			},
			getActivityList(){
					get('/shop/utils/getEnum',{enumType: 'shop_shop_activity_type'}).then((res)=>{
							if(res.success){
									this.activityList = res.enumList
							}
					})
					get('/shop/utils/getEnum',{enumType: 'shop_operation_type'}).then((res)=>{
							if(res.success){
									this.operationTypeList = res.enumList
							}
					})
					get('/shop/utils/getEnum', { enumType: 'store_service_type' }).then((res) => {
							if (res.success && res.code == 200) {
									this.serviveTypeList = res.enumList;
							}
					});
			},
			// 获取对应地址
			getAddress(type, id=null) {
					get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
							if(res.success){
									let array = []
									for (let listElement of res.list) {
											listElement.id = String(listElement.id)
											array.push(listElement)
									}
									if(type == 1){
											this.provinceIdList = array
									}else if(type == 2){
											this.cityIdList = array
									}else if(type == 3){
											this.areaIdList = array
									}else if(type == 4){
											this.streetIdList = array
									}
							}
					})
			},
			openTabs() {
					this.showTabs = true;
					this.tabList = this.mallShop.shopTags == '' ? [] : this.mallShop.shopTags.split(',');
			},
			getSaleModeEnumList(){
					get('/mpp/utils/getEnum',{
							enumType: 'sale_mode',
					}).then((res)=>{
							if(res.success){
									this.saleModeEnumList = res.enumList
							}
					})
			},
			// 获取店铺分类
			getTypeList(){
					get('/shop/shoptype/findAll').then((res)=>{
							if(res.success){
									this.typeList = res.list
							}
					})
			},
			// 获取所属行业
			getIndustryList(){
					get('/shop/shopindustry/findAllAsTree').then((res)=>{
							if(res.success){
									this.industryList = res.treeData
							}
					})
			},
			getLocation(location){
					this.mallShop.shopPosition = `${location.lng},${location.lat}`
					this.mallShop.shopAddress = location.address
					this.getCity = true
					this.getArea = true
					this.street = true
					this.mallShop.provinceId = location.province
					this.mallShop.cityId = location.city
					this.mallShop.areaId = location.area
					this.mallShop.streetId = location.street
			},
			getValueUserId(value) {
					this.mallShop.userId = value;
			},
			handleClose() {
				this.$emit("close");
			},
		},
    components: {
        GridSelect,
        Location
    },
	};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.preview-image {
    width: 200px;
    height: 200px;
    border-radius: 6px;
    display: block;
}

::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}

.avatarWide {
    width: 200px;
    height: 120px;
}
</style>
